import { ParamsHelper } from '../../helpers/ParamsHelper';
import { ApiHttpService } from '../ApiHttpService';
import { FAQSerializer } from '../serializers/FAQSerializer';
import { FAQ } from '../../models/FAQ';

const PRODUCT_QUESTION_PATH = 'articulos/FAQ/';

class FAQsController {
  static async all(id) {
    const response = await ApiHttpService.get(`${PRODUCT_QUESTION_PATH}${id}`);
    const deSerializedData = FAQSerializer.deSerialize(response.data);
    return deSerializedData.map(data => new FAQ(data));
  }

  static create(data) {
    const objectParams = {
      idCliente: data.userId || null,
      nombreCliente: data.userName,
      email: data.email,
      pregunta: data.question,
      artID: data.productId || null,
      motivoConsulta: data.questionReason || null,
    };
    const params = ParamsHelper.createQueryParams(objectParams);
    const headers = {
      captcha: data.recaptchaToken,
    };
    return ApiHttpService.post(`${PRODUCT_QUESTION_PATH}${params}`, {}, false, { headers });
  }
}

export { FAQsController };



// WEBPACK FOOTER //
// ./src/networking/controllers/FAQsController.js